import { PagesPreview } from '../shared/pages-preview';
import { PagesPreviewView } from '../shared/pages-preview.style';
import { useCommonSlideshow } from './slideshow.hooks';
import { ActivityBuilderPrintSlideshowImage } from 'approot/activity-builder/print/activity-builder-print-image.style';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ViewProps } from './slideshow.constants';
import { ImageViewFill } from '../image/image-static-preview';

const SlideshowStaticPreview = ({ slideshowImages, properties }: ViewProps) => {
  const { slides, imageDimensions, setContainerElement } = useCommonSlideshow({
    slideshowImages,
    selectedIndex: 0,
    captureKeypress: false,
  });

  const slide = slides?.[0];

  if (!slide) return null;

  return (
    <ComponentAspectRatio dimensions={properties.dimensionData}>
      <ComponentAbsoluteWrapper $centred={false}>
        <PagesPreview>
          <PagesPreviewView ref={setContainerElement}>
            <ActivityBuilderPrintSlideshowImage>
              {!slide.properties.cropData ? (
                <img
                  src={slide?.properties?.imageUrls?.[0].urls[0].url || ''}
                  alt=""
                  style={{ ...imageDimensions }}
                />
              ) : (
                <ImageViewFill imageUrls={slide?.properties?.imageUrls || []} />
              )}
            </ActivityBuilderPrintSlideshowImage>
          </PagesPreviewView>
        </PagesPreview>
      </ComponentAbsoluteWrapper>
    </ComponentAspectRatio>
  );
};

export default SlideshowStaticPreview;
